import Observer from '@researchgate/react-intersection-observer';
import React from 'react';
export class InfiniteScrollContainer extends React.Component {
  constructor(...args) {
    super(...args);
    this.handleFirstChildChange = (event, unobserve) => {
      window.setTimeout(() => {
        if (event !== null && event !== void 0 && event.isIntersecting) {
          var _this$props$onFirstCh, _this$props;
          unobserve();
          (_this$props$onFirstCh = (_this$props = this.props).onFirstChildEnter) === null || _this$props$onFirstCh === void 0 || _this$props$onFirstCh.call(_this$props, event);
        }
      }, 0);
    };
    this.handleLastChildChange = (event, unobserve) => {
      window.setTimeout(() => {
        if (event.isIntersecting) {
          unobserve();
          this.props.onLastChildEnter(event);
        }
      }, 0);
    };
  }
  render() {
    const {
      children,
      rootId
    } = this.props;
    return React.Children.toArray(children).filter(child => !!child) // Observer throws an error when the child is null
    .map((child, i, array) => {
      const isFirstChild = i === 0;
      const isLastChild = i === array.length - 1;
      if (isLastChild || isFirstChild && this.props.onFirstChildEnter) {
        return /*#__PURE__*/React.createElement(Observer
        // @ts-expect-error props is not recognized on the `child` type
        , Object.assign({}, child.props, {
          onChange: isLastChild ? this.handleLastChildChange : this.handleFirstChildChange,
          root: rootId && `#${rootId}`
          // @ts-expect-error key is not recognized on the `child` type
          ,
          key: child.key
        }), child);
      }
      return child;
    });
  }
}
InfiniteScrollContainer.defaultProps = {
  onFirstChildEnter: undefined,
  rootId: undefined
};
//# sourceMappingURL=infinite-scroll-container.react-component.js.map